@if (ready) {
  <typeahead-v3
    [placeholder]="props.placeholder || ''"
    (selectItem)="selectOption($event)"
    [selectedItem]="selectedItem"
    [items]="items$"
    [key]="field.key"
    [isFilter]="true"
    [clearable]="true"
    [filterCallback]="filterCallback"
  />
}
